import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';

import Form from '../../../components/Form';
import FormField from '../../../components/FormField';
import Loading from '../../../components/Loading';
import useApi from '../../../api';
import useCreateForm from '../../../hooks/useCreateForm';
import useEditForm from '../../../hooks/useEditForm';

const BaseForm = ({ initial, onSubmit, errors }) => (
  <Form onSubmit={onSubmit} initial={initial} errors={errors}>
    {({ data, change, errors, submit }) => (
      <div>
        <FormField
          required
          fullWidth
          type='text'
          margin='normal'
          label={t`Повна назва клубу`}
          id='fullName'
          name='fullName'
          autoComplete='fullName'
          variant='outlined'
          value={data.fullName}
          errors={errors.full_name}
          onChange={change}
        />
        <FormField
          required
          fullWidth
          type='text'
          margin='normal'
          label={t`Коротка назва клубу`}
          id='shortName'
          name='shortName'
          autoComplete='shortName'
          variant='outlined'
          value={data.shortName}
          errors={errors.short_name}
          onChange={change}
        />
        <Button
          style={{ margin: '20px 0 20px 0' }}
          margin='normal'
          type='button'
          fullWidth
          variant='contained'
          color='primary'
          onClick={submit}
        >
          {t`Зберегти`}
        </Button>
      </div>
    )}
  </Form>
);

const getInitialData = (row) => ({
  shortName: row.shortName || '',
  fullName: row.fullName || '',
});

export const EditForm = () => {
  const api = useApi();
  const { loading, data, onSubmit, errors } = useEditForm({
    schema: api.schema.clubs,
    router: api.router.clubs,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Редагувати клуб: ${data.name}`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData(data)}
            onSubmit={onSubmit}
            errors={errors}
            edit
          />
        </Box>
      </Paper>
    </>
  );
};

export const CreateForm = () => {
  const api = useApi();
  const { loading, onSubmit, errors } = useCreateForm({
    schema: api.schema.clubs,
    router: api.router.clubs,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Додати клуб`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData({})}
            onSubmit={onSubmit}
            errors={errors}
            edit={false}
          />
        </Box>
      </Paper>
    </>
  );
};
